/**
 * sis lưu ngôn ngữ là `'vi' | 'en'` (state.common.language), còn API/stored procedure
 * của module Y tế nhận đúng giá trị của adm: `'vn' | 'en'`.
 * Dùng helper này ở mọi chỗ truyền `language` vào url API.
 */
export const toApiLanguage = (language?: string): 'vn' | 'en' => (language === 'en' ? 'en' : 'vn');
